import { Injectable } from '@angular/core';
import basePdfMake from 'pdfmake/build/pdfmake';
import 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { vfs as customVfs } from '../../assets/fonts/pdfmake-vfs';
import { NotoEmojiBase64 } from '../../assets/fonts/notoemoji.base64';

function getPdfMake(): any {
  if (typeof window !== 'undefined') {
    (window as any).pdfMake = (window as any).pdfMake || basePdfMake;
    return (window as any).pdfMake;
  }
  return basePdfMake;
}

let fontsRegistered = false;
const EMOJI_FONT_FILE = 'NotoEmoji-Regular.ttf';
const LEGACY_EMOJI_FONT_FILE = 'NotoSansSymbols-Regular.ttf';

function ensureFontsRegistered(): void {
  const pdfMake = getPdfMake();

  if (!fontsRegistered) {
    if (typeof pdfMake.addVirtualFileSystem === 'function') {
      pdfMake.addVirtualFileSystem(customVfs);
    } else {
      pdfMake.vfs = {
        ...(pdfMake.vfs || {}),
        ...customVfs,
      };
    }

    const existingFonts = pdfMake.fonts || {};
    pdfMake.fonts = {
      ...existingFonts,
      Roboto: existingFonts.Roboto || {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf',
      },
      RobotoCondensed: existingFonts.RobotoCondensed || {
        normal: 'Roboto_Condensed-Regular.ttf',
        bold: 'Roboto_Condensed-Medium.ttf',
        italics: 'Roboto_Condensed-Italic.ttf',
        bolditalics: 'Roboto_Condensed-MediumItalic.ttf',
      },
      Emoji: {
        normal: EMOJI_FONT_FILE,
        bold: EMOJI_FONT_FILE,
        italics: EMOJI_FONT_FILE,
        bolditalics: EMOJI_FONT_FILE,
      },
      EmojiSymbols: {
        normal: LEGACY_EMOJI_FONT_FILE,
        bold: LEGACY_EMOJI_FONT_FILE,
        italics: LEGACY_EMOJI_FONT_FILE,
        bolditalics: LEGACY_EMOJI_FONT_FILE,
      },
    };

    fontsRegistered = true;
  }

  pdfMake.vfs = pdfMake.vfs || {};
  if (!pdfMake.vfs[EMOJI_FONT_FILE]) {
    pdfMake.vfs[EMOJI_FONT_FILE] = NotoEmojiBase64;
  }
}

@Injectable({ providedIn: 'root' })
export class PdfService {
  async printFromPdfmake(docDef: TDocumentDefinitions): Promise<void> {
    ensureFontsRegistered();
    getPdfMake().createPdf(docDef).open();
  }
  async downloadFromPdfmake(docDef: TDocumentDefinitions, fileName: string): Promise<void> {
    ensureFontsRegistered();
    getPdfMake().createPdf(docDef).download(fileName);
  }
}
